import React, { memo } from "react";
import { TableCell, TableCellProps } from "@mui/material";
import { cn } from "@/utils/common.utils";

const AppTabCell = ({
  children,
  className,
  sx,
  ...otherProps
}: TableCellProps) => {
  return (
    <TableCell
      className={className}
      sx={{
        fontSize: "14px",
        ...sx,
      }}
      {...otherProps}
    >
      {children}
    </TableCell>
  );
};

export default memo(AppTabCell);
